import React from "react";
import { PieChart, Pie, ResponsiveContainer, Cell } from 'recharts';


const COLORS = ['#24b7bb', '#006291', '#001248'];//, '#008CAA', '#24B7BB'
const RADIAN = Math.PI / 180;



const renderCustomizedLabel = (props, data) => {

  const { cx, cy, midAngle, innerRadius, outerRadius, percent, index } = props
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * (Math.cos(-midAngle * RADIAN)) + 5;
  const y = cy + radius * (Math.sin(-midAngle * RADIAN));
  const radiusLabel = 20 + innerRadius + (outerRadius - innerRadius);
  // eslint-disable-next-line
  const xlabel = cx + radiusLabel * Math.cos(-midAngle * RADIAN);
  // eslint-disable-next-line
  const ylabel = cy + radiusLabel * Math.sin(-midAngle * RADIAN);
  return (
    <>
      <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
        {`${(percent * 100).toFixed(0)}%`}
      </text>
      <text
        x={xlabel}
        y={ylabel}
        fill={props.fill}
        textAnchor={xlabel > cx ? "start" : "end"}
        dominantBaseline="central"
        style={{fontSize: 10}}
      >
       {data[index].name}
      </text>
    </>
  );
};


class myPieChart extends React.Component {


    render() {
        const Sourcedata = this.props.data

        const data=[]

        let first=0;
        let last=Sourcedata.length-1

        while (first<=last) {
          if (first!==last) {
            data.push(Sourcedata[first])
            data.push(Sourcedata[last])
          } else 
            data.push(Sourcedata[first])

            first=first+1
            last=last-1
        }


        return (

            <div className={this.props.className} data-aos="fade-up" data-aos-delay="200">
                <div className='HomeBlock graphic' >
                    <p className='HomeBlockTitle'>{this.props.title}</p><br />
                    {data !== undefined ?
                        <ResponsiveContainer width="100%">
                            <PieChart >
                                <Pie
                                    data={data}
                                    cx="50%"
                                    cy="40%"
                                    outerRadius={120}
                                    innerRadius={30}

                                    fill="#8884d8"
                                    dataKey="value"
                                    label={(props) => renderCustomizedLabel(props, data)}
                                >
                                    {data.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                </Pie>
                            </PieChart>
                        </ResponsiveContainer> :
                        null}
                </div>
            </div>
        )
    }
}

export default myPieChart